import { apiFetch } from "./client";
import type { components } from "./schema";

export type ReportCreate = components["schemas"]["ReportCreate"];
export type ReportCreated = components["schemas"]["ReportCreated"];

/** One finding of the personal-data filter (`422 contains_personal_data`, `details.findings`). */
export interface PersonalDataFinding {
  field: "tip_text" | "reason_note";
  kind: string;
  start: number;
  end: number;
}

export function createReport(companyId: string, body: ReportCreate): Promise<ReportCreated> {
  return apiFetch<ReportCreated>(`/companies/${encodeURIComponent(companyId)}/reports`, {
    method: "POST",
    json: body,
  });
}

export function undoReport(id: string): Promise<void> {
  return apiFetch<undefined>(`/reports/${encodeURIComponent(id)}`, { method: "DELETE" });
}
